import { HiddenContent } from "components/HiddenContent/HiddenContent";
import { TextTruncate } from "../../../../components";
import { PublishStatus } from "components/common/PublishStatus";
import { Tooltip } from "../../../../components/common/tooltip";
import { Title } from "../../../../components/listViewTemplates";
import { PublishedStatusTypes, SortOptions } from "../../../../enums";
import { type ColumnOption } from "../../../../interfaces/columnOptions";
import dateTimeUtils from "../../../../utils/dateTimeUtils";
import { VideoColumns, type VideoOverview } from "../types/models";
import { VideoContentItemMenu } from "./VideoContentItemMenu/VideoContentItemMenu";
import cn from "classnames";

export const sortOptions = [
  {
    text: "Most Recent",
    value: SortOptions.CreatedDateDesc,
    default: true,
  },
  {
    text: "Last Modified",
    value: SortOptions.ModifiedDateDesc,
  },
  {
    text: "Sorted A-Z",
    value: SortOptions.Title,
  },
];

export interface GetColumnOptionsParams {
  readonly?: boolean;
  buttonHandlers: {
    handleEditClick: (id: number, isDraft: boolean) => () => void;
    handlePublishClick: (id: number, isDraft: boolean, flowsCount: number, hasBeenPublished: boolean) => () => void;
    handleDeleteClick: (ids: number[], flowsCount?: number, packsCount?: number) => () => void;
    onToggleVisibility: (id: number[], hidden: boolean) => () => void;
  };
}

export const getColumnOptions = (params: GetColumnOptionsParams): ColumnOption<VideoOverview>[] => {
  return [
    {
      name: VideoColumns.Title,
      width: 4,
      isSortable: true,
      render: (video) => (
        <HiddenContent variant="list" isHidden={!video.visibility} showIcon>
          <Title
            url={video.id.toString()}
            title={video.title}
            clamp={2}
            className={cn("normal-color", { "hidden-content": !video.visibility })}
          />
        </HiddenContent>
      ),
    },
    {
      name: VideoColumns.Publisher,
      width: 3,
      isSortable: false,
      render: (video) => (
        <Tooltip
          className={cn({ "hidden-content": !video.visibility })}
          target={
            <TextTruncate>
              <HiddenContent variant="list" isHidden={!video.visibility}>
                {video.publisher}
              </HiddenContent>
            </TextTruncate>
          }
          content={video.publisher}
        />
      ),
    },
    {
      name: VideoColumns.Status,
      width: 3,
      isSortable: false,
      render: (video) => (
        <HiddenContent variant="list" isHidden={!video.visibility}>
          <PublishStatus
            publishedStatus={PublishedStatusTypes.ConvertToPublishedStatusType(!video.isDraft, video.hasBeenPublished)}
          />
        </HiddenContent>
      ),
    },
    {
      name: VideoColumns.Added,
      width: 2,
      isSortable: true,
      render: (video) => (
        <HiddenContent variant="list" isHidden={!video.visibility}>
          {dateTimeUtils.formatDate(video.dateCreated)}
        </HiddenContent>
      ),
    },
    {
      name: VideoColumns.Modified,
      width: 2,
      isSortable: true,
      render: (video) => (
        <HiddenContent variant="list" isHidden={!video.visibility}>
          {dateTimeUtils.formatDate(video.dateModified)}
        </HiddenContent>
      ),
    },
    {
      name: "",
      width: 1,
      className: "align-right",
      isSortable: false,
      render: (video, isChecked) => {
        return (
          <VideoContentItemMenu
            {...params.buttonHandlers}
            circle
            outlinedEllipsis
            item={video}
            isChecked={isChecked}
            readonly={params.readonly}
            hasPermission={!params.readonly}
          />
        );
      },
    },
  ];
};
